<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="池组名称：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item>
      <el-form-item label="余额低于：">
        <el-input v-model.trim="searchForm.amount" placeholder="池组余额低于多少元" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getOldToNewListHandler" plain icon="el-icon-search">搜索查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tbpg.tableData" border>
      <el-table-column prop="name" label="池组名称" width="160" align="center"></el-table-column>
      <el-table-column prop="agentName" label="代理商" width="160" align="center"></el-table-column>
      <el-table-column prop="price" label="单价（元）" align="center"></el-table-column>
      <el-table-column prop="poolYa" label="保证金（元）" align="center"></el-table-column>
      <el-table-column prop="amount" label="余额（元）" align="center"></el-table-column>
      <el-table-column prop="totalSim" label="总卡数" align="center"></el-table-column>
      <el-table-column prop="activeSim" label="总激活数" align="center"></el-table-column>
      <el-table-column prop="activingSim" label="月激活数" align="center"></el-table-column>
      <el-table-column prop="monthUse" label="使用流量（G）" width="110" align="center"></el-table-column>
      <el-table-column prop="monthPrice" label="产生费用（元）" width="110" align="center"></el-table-column>
      <el-table-column prop="minUse" label="抵消（G）" align="center"></el-table-column>
      <el-table-column prop="minPrice" label="最低消费（元）" width="110" align="center"></el-table-column>
      <el-table-column prop="stopPrice" label="保号费（元）" width="120" align="center"></el-table-column>
      <el-table-column prop="createTime" label="时间" width="160" align="center"></el-table-column>

      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="addPoolAmount(scope.row.id)">账户充值</el-button>
          <el-button type="primary" size="small" @click="selectYu(scope.row)">余额流水</el-button>
        </template>
      </el-table-column>
    </el-table>





    <el-dialog :append-to-body="true" title="流水记录" :visible.sync="actionLogVisible" width="1000px"
      :close-on-click-modal="false">
      <el-table :data="actionLogTbpg.tableData" border height="421">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="amount" label="交易金额"></el-table-column>
        <el-table-column prop="balance" label="交易余额"></el-table-column>
        <el-table-column prop="typeName" label="交易类型" width="100"></el-table-column>
        <el-table-column prop="remark" label="交易备注"></el-table-column>
        <el-table-column prop="createName" label="系统备注"></el-table-column>
        <el-table-column prop="createTime" label="交易时间" width="140"></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
        :current-page="actionLogTbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="actionLogTbpg.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="actionLogTbpg.total">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="actionLogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>



    <el-dialog :append-to-body="true" title="池组加款" :visible.sync="amountFlg" width="600px" @close="amountFlg = false"
      :close-on-click-modal="false">
      <el-form ref="amountData" :model="amountData" label-width="120px">
        <el-form-item label="充值金额：" prop="amount">

          <el-input-number v-model="amountData.amount" :precision="2" :step="500" :min="0">
          </el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="amountFlg = false">取 消</el-button>
        <el-button type="primary" @click="sureUpdate()">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" title="打开微信扫一扫进行充值" :visible.sync="payFlg" width="600px" @close="payFlg=false"
      :close-on-click-modal="false">

      <div style="text-align: center; width: 500px; border: ">
        <img :src="getImgUrl() + payImg" alt="" width="300px" height="300px" style="margin: 0 auto;">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureInvent">已 充 值</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('代理商手机号有误，请重新输入。'))
      } else {
        callback()
      }
    }
    return {
      amountData: {
        id: '',
        amount: ''
      },
      amountFlg: false,


      actionLogVisible: false,
      actionLogTbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0
      },



      agentListOption: [],
      searchForm: {
        name: "",
        storeType: "",
        // moveIds: [],
      },
      moveIdsList: [],
      storeStateList: [
        { label: '暂不操作', id: '0' },
        { label: '关停接口', id: '1' },
        { label: '卡板停机', id: '2' }],
      title: '',
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      rules: {
        name: [
          { required: true, message: '店铺名称不能为空', trigger: ['blur', 'change'] }
        ],
        type: [
          { required: true, message: '超套设置', trigger: ['blur', 'change'] }
        ],
        agentId: [
          { required: true, message: '代理商不能为空', trigger: ['blur', 'change'] }
        ],
        price: [
          { required: true, message: '单价不能为空', trigger: ['blur', 'change'] }
        ],
        supplierId: [
          { required: true, message: '供应商不能为空', trigger: ['blur', 'change'] }
        ],

      },
      branchSupplierOption: [],
      toNewCardVisible: false, //显示新增编辑弹窗
      toNewCardForm: {
        id: '',
        name: '',
        type: '',
        supplierId: '',
        agentId: '',
        price: '',
        minUse: '',
        stopPrice: '',
      },
      selectInfoId: '',


      payImg: '',
      payFlg: false,

    };
  },
  created() {
    common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
    common.getAgentListOptionCom(this, 'agentListOption');
    this.getOldToNewListHandler();
  },
  methods: {
    addPoolAmount(id) {
      this.amountData.id = id;
      this.amountFlg = true;
    },
    handleSizeChanges(val) {
      this.actionLogTbpg.pageSize = val;
      this.selectYu();
    },
    handleCurrentChanges(val) {
      this.actionLogTbpg.currentPage = val
      this.selectYu();
    },


    exportApplyHandler(row) {
      var data = {
        id: row.id
      }
      this.$confirm('确定导出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        common.sysRequest('export/poolSim', data, 'post').then(res => {
          if (res.data.code == 200) {
            this.$message.success('数据导出中,请稍候去任务中心下载');
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }).catch(() => {

      });
    },

    updateYu(row) {
      this.amountData.id = row.id;
      this.amountData.type = '';
      this.amountData.amount = '';
      this.amountData.remark = '';
      this.amountFlg = true;
    },
    sureUpdate() {
      common.sysRequest('pool/add/agent/pool', this.amountData, 'post').then(res => {
        if (res.data.code == 200) {
          this.payImg = res.data.data.img;
          this.payFlg = true;
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    sureInvent(){
      this.payFlg = false;
      this.amountFlg = false;
      this.getOldToNewListHandler();
    },

    selectYu(row, $event) {
      if (row && row.id) {
        this.selectInfoId = row.id;
      }
      common.resetCurrentPage(this, $event, 'actionLogTbpg');
      let data = common.getRequestParams(this, 'actionLogTbpg', { id: this.selectInfoId });
      common.sysRequest('pool/select/amount/info', data, 'post').then(res => {
        common.listCallback(this, res, 'actionLogTbpg');
        this.actionLogVisible = true;
      })
    },
    deletePool(id) {

    },
    cancel() {
      this.toNewCardForm = {};
      this.$refs['toNewCardForm'].resetFields();
      this.toNewCardVisible = false;
      this.$forceUpdate()
    },
    getOldToNewListHandler($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      common.sysRequest('pool//select/all/task/page', data, 'post').then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },


    addStore() {
      this.toNewCardVisible = true;
      this.toNewCardForm.id = ''
      this.title = '新增池组'
      this.$forceUpdate()
    },
    sureToNewCardHandler() {
    },
    dataEdit(data) {
      this.title = '编辑池组'
      this.toNewCardForm = data
      this.toNewCardForm.type = data.type;
      this.toNewCardVisible = true;
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getOldToNewListHandler();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getOldToNewListHandler();
    },
    change(e) {
      this.$forceUpdate()
    },
    addressChange(arr) {

    },

  }
};
</script>

<style lang="less" scoped></style>
